import { ClientInfluencerAccount } from '../../helpers';
import useUserAnalytics from '../../useUserAnalytics';
import GenderChart from './GenderChart';
import styles from './Audience.module.css';
import AgeGenderDistributionChart from './AgeGenderDistributionChart';
import TopCountries from './TopCountries';
import TopLanguages from './TopLanguages';

type Props = {
    account: ClientInfluencerAccount | undefined | null;
    isLoading?: boolean;
};

const Audience = ({ account, isLoading }: Props) => {
    const {
        data,
        isLoading: isAnalyticsLoading,
        errorMessage: analyticsErrorMessage,
    } = useUserAnalytics(account, {
        enabled: !!account && !isLoading,
    });

    const isDataLoading = isAnalyticsLoading || isLoading;
    const genderAgeDistribution = data?.profile?.audience?.gender_age_distribution ?? [];
    const hasGenderAgeData = genderAgeDistribution.length > 0;

    return (
        <div className={styles.container}>
            <TopCountries
                data={data?.profile?.audience?.countries ?? []}
                isLoading={isDataLoading}
                errorMessage={analyticsErrorMessage}
            />

            <TopLanguages
                data={data?.profile?.audience?.languages ?? []}
                isLoading={isDataLoading}
                errorMessage={analyticsErrorMessage}
            />

            {hasGenderAgeData && (
                <>
                    <GenderChart
                        data={genderAgeDistribution}
                        isLoading={isDataLoading}
                        errorMessage={analyticsErrorMessage}
                    />

                    <AgeGenderDistributionChart
                        data={genderAgeDistribution}
                        isLoading={isDataLoading}
                        errorMessage={analyticsErrorMessage}
                    />
                </>
            )}
        </div>
    );
};

export default Audience;
